@let PADDING = 40;
@let FONT = '36px DINRoundPro';

<div
  #rootEl
  class="ease-out-back relative isolate grid place-items-center transition-all"
  [style.width.px]="shown()?.k ?? '' | textWidth: FONT : PADDING"
>
  @for (current of [shown()]; track current?.id) {
    <div
      class="absolute w-full transition-transform"
      [class]="{
        '-rotate-15': pendingNeighbor() === 'AFTER',
        'rotate-15': pendingNeighbor() === 'BEFORE',
        'translate-y-8': isPendingRemoval(),
        'translate-x-8': pendingNeighbor() === 'BEFORE',
        '-translate-x-8': pendingNeighbor() === 'AFTER',
      }"
      [style.width.px]="current?.k ?? '' | textWidth: FONT : PADDING"
    >
      <rid-klank-card
        class="absolute"
        [klank]="current?.k ?? ''"
        animate.enter="klank-enter"
        animate.leave="klank-leave"
        [disabled]="isPendingRemoval()"
      />
    </div>
  }
</div>
